import { render } from "./AnimationPage.vue?vue&type=template&id=096e7e16&scoped=true&ts=true"
import script from "./AnimationPage.vue?vue&type=script&lang=ts"
export * from "./AnimationPage.vue?vue&type=script&lang=ts"

import "./AnimationPage.vue?vue&type=style&index=0&id=096e7e16&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096e7e16"]])

export default __exports__